// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoDataRowModel {
    static getAttributeTypeMap() {
        return PorticoDataRowModel.attributeTypeMap;
    }
}
PorticoDataRowModel.discriminator = undefined;
PorticoDataRowModel.additionalProperties = false;
PorticoDataRowModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "dataTableId",
        "baseName": "dataTableId",
        "type": "string"
    },
    {
        "name": "dataGroupId",
        "baseName": "dataGroupId",
        "type": "string"
    },
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "dataValues",
        "baseName": "dataValues",
        "type": "Array<PorticoDataValueModel>"
    },
];
//# sourceMappingURL=porticoDataRowModel.js.map